import React, {
  createContext
} from 'react';

import {
  DealSortOrders,
  PackageTypes
} from 'src/Common/constants';

export const SalesContext = createContext();

export const SalesConsumer = SalesContext.Consumer;

export class SalesProvider extends React.Component {
  state = {
    isUserExisting: false,
    address: 'testAddress',
    filterAwsUrl: '',
    productsAwsUrl: '',
    contractTermAwsUrl: '',
    filters: {
      downloadSpeed: [],
      selectedSpeeds: [],
      onPromotion: false
    },
    providerPackages: [],
    topPicks: [],
    plans: [],
    planProviders: [],
    contractOptions: [],
    contractTerms: [],
    selectedPlanProvider: {},
    providerList: '',
    filterList: {},
    filteredProviderPackages: null,
    helpMeChoosePackages: null,
    pageNos: null,
    sortOrder: DealSortOrders.ASC,
    pageOffset: 1,
    userExistingProperties: {
      hideBankYrs: false,
      hideVetAddress: false
    },
    userDetails: {
      firstName: '',
      lastName: '',
      email: '',
      referenceNo: '',
      contactNumber: '',
      quoteNumber: ''
    },
    existingUserContactNumber: '',
    suggestedPlan: null,
    showSpinner: false,
    deliveryAddress: {
      unitNumber: '',
      buildingName: '',
      streetAddress: '',
      suburb: '',
      city: '',
      province: '',
      postalCode: ''
    },
    installationAddress: {
      unitNumber: '101',
      buildingName: 'Building',
      streetAddress: '404 Main Avenue',
      suburb: 'Ferndale',
      city: 'Randburg',
      province: 'Gauteng',
      postalCode: '2194',
      latitude: '',
      longitude: '',
      docid: ''
    },
    totalMonthlyCost: '',
    contractTerm: null,
    selectedPageNo: 1,
    selectedContractTerm: 'Month to Month',
    selectedPackage: null,
    installationCost: null,
    additionalServices: null,
    selectedAdditionalServices: {
      lte: false,
      superWifi: false,
      voiceLine: false,
      contractCover: false
    },
    deliveryAddressType: null,
    employmentDetails: {
      employmentType: '',
      employerName: '',
      passportIssueCountry: '',
      idNumber: '',
      passportNumber: '',
      dateOfExpiry: '',
      cellPhoneNo: '',
      selectedIdTab: 'idNumber'
    },
    providers: null,
    termsAccepted: null,

    vumaInstallationAddress: null,
    vumaPaymentMethod: null,
    vumaPaymentOption: null,
    vumaSelectedProductID: null,
    vumaProductType: '',
    recurringOfferProducts: {},
    voucherOfferProducts: {},
    vumaContactDetails: {
      firstName: '',
      lastName: '',
      email: '',
      cellPhone: ''
    },
    selectedVumaProduct: null,
    selectedVumaContractTerms: null,
    errorObject: null,
    getOffersError: false,
    sanitizedInstallationAddress: null,
    vettingCreditDetails: {
      personalDetails: null,
      contactDetails: null,
      workDetails: null,
      homeAddress: null,
      postalAddress: null,
      bankDetails: null,
      creditCheckDetails: null
    },
    vettingSameAsInstallationAddress: null,
    vettingSameAsHomeAddress: null,
    provinceList: null,
    dropDownValues: null,
    fileUploadId: null,
    fileUploadBankStatement: null,
    fileUploadSaWorkPermit: null,
    isUnemployed: null,
    newCustomerErrorObject: null,
    leadAdditionalServices: [],
    createQuoteCallPayload: null,
    additionalVas: null,
    lteReviewData: null,
    priceValue: 0,
    selectedPackageType: PackageTypes.StandaloneFibreDeals,
    debiCheckSelected: false,
    showCallMeBack: false,
    unselectedContractCover: false
  };

  setShowCallMeBack = (value) => {
    this.setState({
      ...this.state,
      showCallMeBack: value
    });
  }

  setDebiCheckSelected = (value) => {
    this.setState({
      ...this.state,
      debiCheckSelected: value
    });
  }

  setSelectedPackageType = (value) => {
    this.setState({
      selectedPackageType: value
    });
  }

  setIsUnemployed = (value) => {
    this.setState({
      ...this.state,
      isUnemployed: value
    });
  };

  setDropDownValues = (data) => {
    this.setState({
      ...this.state,
      dropDownValues: data
    });
  };

  setVettingSameAsInstallationAddress = (value) => {
    this.setState({
      ...this.state,
      vettingSameAsInstallationAddress: value
    });
  };

  setVettingSameAsHomeAddress = (value) => {
    this.setState({
      ...this.state,
      vettingSameAsHomeAddress: value
    });
  };

  setProvinceList = (list) => {
    this.setState({
      ...this.state,
      provinceList: list
    });
  };

  setVettingDetails = (key, value) => {
    if(key){
      this.setState({
        vettingCreditDetails: {
          ...this.state.vettingCreditDetails,
          [key]: value
        }
      });
    } else {
      this.setState({
        vettingCreditDetails: {
          personalDetails: null,
          contactDetails: null,
          workDetails: null,
          homeAddress: null,
          postalAddress: null,
          bankDetails: null,
          creditCheckDetails: null
        }
      });
    }
  };

  setTermsAccepted = (value) => {
    this.setState({
      termsAccepted: value
    });
  };

  setEmploymentDetails = (obj) => {
    const newEmploymentDetails = {
      ...this.state.employmentDetails,
      [obj.key]: obj.value
    };
    if (obj.key === 'employmentType' && obj.value !== 'Employee') {
      newEmploymentDetails.employerName = '';
    }

    this.setState({
      employmentDetails: newEmploymentDetails
    });
  };

  setContractTermAwsUrl = (contractTermUrl) => {
    this.setState({
      contractTermAwsUrl: contractTermUrl
    });
  };

  setAdditionalServices = (obj) => {
    this.setState({
      additionalServices: obj
    });
  };

  setLeadAdditionalServices = (obj) => {
    this.setState({
      leadAdditionalServices: obj
    });
  };

  setProviders = (obj) => {
    if (!obj || !obj.key) {
      return;
    }

    this.setState((state) => ({
      providers: {
        ...state.providers,
        [obj.key]: obj.value
      }
    }));
  };

  setSelectedAdditionalServices = (obj) => {
    if (!obj || !obj.key) {
      return;
    }

    this.setState((state) => ({
      selectedAdditionalServices: {
        ...state.selectedAdditionalServices,
        [obj.key]: obj.value
      }
    }));
  };

  setProviderList = (providerList) => {
    this.setState({
      providerList: providerList
    });
  };

  setSelectedContractTerm = (contractTermObj) => {
    this.setState({
      selectedContractTerm: contractTermObj
    });
  };

  setContractTerm = (contractTerm) => {
    this.setState({
      contractTerm: contractTerm
    });
  };

  setMonthlyCost = (totalMonthlyCost) => {
    this.setState({
      totalMonthlyCost: totalMonthlyCost
    });
  };

  setSelectedPageNo = (pageNo) => {
    this.setState({
      selectedPageNo: pageNo
    });
  };

  setInstallationAddress = (obj) => {
    this.setState({
      installationAddress: obj
    });
  };

  setDeliveryAddress = (obj) => {
    const newAddress = { ...this.state.deliveryAddress, [obj.key]: obj.value };
    this.setState({
      deliveryAddress: newAddress
    });
  };

  setShowSpinner = (value) => {
    this.setState({
      showSpinner: value
    });
  };

  setSuggestedPlan = (plan) => {
    this.setState({
      suggestedPlan: plan
    });
  };

  setFilterList = (filterList) => {
    this.setState({
      filterList: filterList
    });
  };

  setPageOffset = (offset) => {
    this.setState({
      pageOffset: offset
    });
  };

  setSortOrder = (order) => {
    this.setState({
      sortOrder: order
    });
  };

  setPageNos = (pageNos, callback) => {
    this.setState({
      pageNos: pageNos
    }, callback);
  };

  setFilterAwsUrl = (filterUrl) => {
    this.setState({
      filterAwsUrl: filterUrl
    });
  };

  setProductsAwsUrl = (productUrl) => {
    this.setState({
      productsAwsUrl: productUrl
    });
  };

  setFilters = (filters) => {
    this.setState({
      filters: filters
    });
  };

  setFilteredProviderPackages = (providers) => {
    this.setState({
      filteredProviderPackages: providers
    });
  };

  setHelpMeChoosePackages = (providers) => {
    this.setState({
      helpMeChoosePackages: providers
    });
  };

  setPlans = (plans) => {
    this.setState({
      plans: plans
    });
  };

  setPlanProviders = (planProviders) => {
    this.setState({
      planProviders
    });
  };

  setContractOptions = (contractOptions) => {
    this.setState({
      contractOptions
    });
  };

  setContractTerms = (contractTerms) => {
    this.setState({
      contractTerms
    });
  };

  setProviderPackages = (providers) => {
    providers && providers.map(
      (provider) =>
        (provider.description =
          provider.download + ' / ' + provider.dataCap)
    );
    this.setState({
      providerPackages: providers
    });
  };

  setTopPicks = (providers) => {

    this.setState({
      ...this.state,
      topPicks: providers
    });
  };

  setSelectedPackage = (providerPackage) => {
    this.setState((state) => {
      return {
        selectedPackage: {
          ...state.selectedPackage,
          ...providerPackage
        }
      };
    });
  };

  setUserDetails = (user) => {
    const newUserDetails = {
      ...this.state.userDetails,
      [user.key]: user.value
    };
    this.setState({
      userDetails: newUserDetails
    });
  };

  setUserExistingProperties = (properties) => {
    this.setState(state => ({
      userExistingProperties: {
        ...state.userExistingProperties,
        [properties.key]: properties.value
      }
    }));
  };

  setUserDetailsObject = (userDetailsObj) => {
    this.setState({
      userDetails: userDetailsObj
    });
  };

  setDeliveryAddressType = (type) => {
    this.setState({
      deliveryAddressType: type
    });
  };

  setIsUserExisting = (value) => {
    this.setState({
      isUserExisting: value
    });
  };

  setExistingUserContactNumber = (value) => {
    this.setState({
      existingUserContactNumber: value
    });
  };

  setVumaInstallationAddress = (value) => {
    this.setState({
      vumaInstallationAddress: value
    });
  };

  setVumaProductType = (value) => {
    this.setState({
      vumaProductType: value
    });
  };

  setVumaPaymentMethod = (method) => {
    this.setState({
      vumaPaymentMethod: method
    });
  };

  setVumaPaymentOption = (option) => {
    this.setState({
      vumaPaymentOption: option
    });
  };

  setVumaSelectedProductID = (option) => {
    this.setState({
      vumaSelectedProductID: option
    });
  };

  setVoucherOfferProducts = (data) => {
    this.setState({
      voucherOfferProducts: data
    });
  };

  setRecurringOfferProducts = (data) => {
    this.setState({
      recurringOfferProducts: data
    });
  };

  setVumaContactDetails = (data) => {
    this.setState({
      vumaContactDetails: data
    });
  };

  setSelectedVumaProduct = (product) => {
    this.setState({
      selectedVumaProduct: product
    });
  };

  setSelectedVumaContractTerms = (product) => {
    this.setState({
      selectedVumaContractTerms: product
    });
  };

  resetVumaProductDetails = () => {
    this.setState({
      vumaPaymentMethod: null,
      vumaPaymentOption: null,
      voucherOfferProducts: null,
      recurringOfferProducts: null,
      selectedVumaProduct: null
    });
  };

  setErrorObject = (obj) => {
    this.setState({
      errorObject: obj
    });
  };

  setGetOffersError = (hasError) => {
    this.setState({
      getOffersError: hasError
    });
  };

  setSanitizedInstallationAddress = (address) => {
    this.setState({
      sanitizedInstallationAddress: address
    });
  };

  setFileUploadId = (file) => {
    this.setState({
      fileUploadId: file
    });
  };

  setFileUploadBankStatement = (file) => {
    this.setState({
      fileUploadBankStatement: file
    });
  };

  setFileUploadSaWorkPermit = (file) => {
    this.setState({
      fileUploadSaWorkPermit: file
    });
  };

  setNewCustomerErrorObject = (obj) => {
    this.setState({
      newCustomerErrorObject: obj
    });
  };

  setCreateQuoteCallPayload = payload => {
    this.setState({
      createQuoteCallPayload: payload
    });
  }

  setAdditionalServicesLte = (obj) => {
    this.setState({
      additionalVas: obj
    });
  };

  setAdditionalVas = (obj) => {
    this.setState({
      additionalVas: obj
    });
  };

  setLteReviewData = (obj) => {
    this.setState({
      lteReviewData: obj
    });
  }
  setUnselectedContractCover = (data) => {
    this.setState({
      unselectedContractCover: data
    });
  }

  render() {
    return (
      <SalesContext.Provider
        value={{
          isUserExisting: this.state.isUserExisting,
          address: this.state.address,
          filterAwsUrl: this.state.filterAwsUrl,
          productsAwsUrl: this.state.productsAwsUrl,
          filters: this.state.filters,
          providerPackages: this.state.providerPackages,
          topPicks: this.state.topPicks,
          providerList: this.state.providerList,
          leadAdditionalServices: this.state.leadAdditionalServices,
          filterList: this.state.filterList,
          selectedPackage: this.state.selectedPackage,
          pageNos: this.state.pageNos,
          filteredProviderPackages: this.state.filteredProviderPackages,
          helpMeChoosePackages: this.state.helpMeChoosePackages,
          plans: this.state.plans,
          planProviders: this.state.planProviders,
          contractOptions: this.state.contractOptions,
          contractTerms: this.state.contractTerms,
          sortOrder: this.state.sortOrder,
          pageSize: this.state.pageSize,
          pageOffset: this.state.pageOffset,
          userDetails: this.state.userDetails,
          userExistingProperties: this.state.userExistingProperties,
          suggestedPlan: this.state.suggestedPlan,
          showSpinner: this.state.showSpinner,
          deliveryAddress: this.state.deliveryAddress,
          installationAddress: this.state.installationAddress,
          selectedPageNo: this.state.selectedPageNo,
          contractTerm: this.state.contractTerm,
          selectedContractTerm: this.state.selectedContractTerm,
          additionalServices: this.state.additionalServices,
          deliveryAddressType: this.state.deliveryAddressType,
          contractTermAwsUrl: this.state.contractTermAwsUrl,
          employmentDetails: this.state.employmentDetails,
          selectedAdditionalServices: this.state.selectedAdditionalServices,
          providers: this.state.providers,
          termsAccepted: this.state.termsAccepted,
          existingUserContactNumber: this.state.existingUserContactNumber,
          vumaInstallationAddress: this.state.vumaInstallationAddress,
          vumaPaymentMethod: this.state.vumaPaymentMethod,
          vumaPaymentOption: this.state.vumaPaymentOption,
          vumaSelectedProductID: this.state.vumaSelectedProductID,
          vumaProductType: this.state.vumaProductType,
          recurringOfferProducts: this.state.recurringOfferProducts,
          voucherOfferProducts: this.state.voucherOfferProducts,
          vumaContactDetails: this.state.vumaContactDetails,
          selectedVumaProduct: this.state.selectedVumaProduct,
          selectedVumaContractTerms: this.state.selectedVumaContractTerms,
          errorObject: this.state.errorObject,
          getOffersError: this.state.getOffersError,
          sanitizedInstallationAddress: this.state.sanitizedInstallationAddress,
          vettingCreditDetails: this.state.vettingCreditDetails,
          provinceList: this.state.provinceList,
          vettingSameAsInstallationAddress: this.state.vettingSameAsInstallationAddress,
          vettingSameAsHomeAddress: this.state.vettingSameAsHomeAddress,
          dropDownValues: this.state.dropDownValues,
          fileUploadId: this.state.fileUploadId,
          fileUploadBankStatement: this.state.fileUploadBankStatement,
          fileUploadSaWorkPermit: this.state.fileUploadSaWorkPermit,
          isUnemployed: this.state.isUnemployed,
          newCustomerErrorObject: this.state.newCustomerErrorObject,
          createQuoteCallPayload: this.state.createQuoteCallPayload,
          additionalVas: this.state.additionalVas,
          lteReviewData: this.state.lteReviewData,
          selectedPackageType: this.state.selectedPackageType,
          debiCheckSelected: this.state.debiCheckSelected,
          showCallMeBack: this.state.showCallMeBack,
          unselectedContractCover: this.state.unselectedContractCover,
          totalMonthlyCost: this.state.totalMonthlyCost,

          setProductsAwsUrl: this.setProductsAwsUrl,
          setFilterAwsUrl: this.setFilterAwsUrl,
          setLeadAdditionalServices: this.setLeadAdditionalServices,
          setFilters: this.setFilters,
          setProviderPackages: this.setProviderPackages,
          setTopPicks: this.setTopPicks,
          setSelectedPackage: this.setSelectedPackage,
          setPageNos: this.setPageNos,
          setSortOrder: this.setSortOrder,
          setPageOffset: this.setPageOffset,
          setUserDetails: this.setUserDetails,
          setUserExistingProperties: this.setUserExistingProperties,
          setFilterList: this.setFilterList,
          setSuggestedPlan: this.setSuggestedPlan,
          setShowSpinner: this.setShowSpinner,
          setFilteredProviderPackages: this.setFilteredProviderPackages,
          setHelpMeChoosePackages: this.setHelpMeChoosePackages,
          setPlans: this.setPlans,
          setContractOptions: this.setContractOptions,
          setContractTerms: this.setContractTerms,
          setPlanProviders: this.setPlanProviders,
          setDeliveryAddress: this.setDeliveryAddress,
          setInstallationAddress: this.setInstallationAddress,
          setSelectedPageNo: this.setSelectedPageNo,
          setContractTerm: this.setContractTerm,
          setSelectedContractTerm: this.setSelectedContractTerm,
          setProviderList: this.setProviderList,
          setAdditionalServices: this.setAdditionalServices,
          setDeliveryAddressType: this.setDeliveryAddressType,
          setContractTermAwsUrl: this.setContractTermAwsUrl,
          setEmploymentDetails: this.setEmploymentDetails,
          setSelectedAdditionalServices: this.setSelectedAdditionalServices,
          setIsUserExisting: this.setIsUserExisting,
          setProviders: this.setProviders,
          setTermsAccepted: this.setTermsAccepted,
          setExistingUserContactNumber: this.setExistingUserContactNumber,
          setVumaInstallationAddress: this.setVumaInstallationAddress,
          setVumaPaymentMethod: this.setVumaPaymentMethod,
          setVumaPaymentOption: this.setVumaPaymentOption,
          setVumaSelectedProductID: this.setVumaSelectedProductID,
          setVumaProductType: this.setVumaProductType,
          setVoucherOfferProducts: this.setVoucherOfferProducts,
          setRecurringOfferProducts: this.setRecurringOfferProducts,
          setVumaContactDetails: this.setVumaContactDetails,
          setSelectedVumaProduct: this.setSelectedVumaProduct,
          setSelectedVumaContractTerms: this.setSelectedVumaContractTerms,
          resetVumaProductDetails: this.resetVumaProductDetails,
          setErrorObject: this.setErrorObject,
          setGetOffersError: this.setGetOffersError,
          setSanitizedInstallationAddress: this.setSanitizedInstallationAddress,
          setVettingDetails: this.setVettingDetails,
          setProvinceList: this.setProvinceList,
          setVettingSameAsInstallationAddress: this.setVettingSameAsInstallationAddress,
          setVettingSameAsHomeAddress: this.setVettingSameAsHomeAddress,
          setDropDownValues: this.setDropDownValues,
          setFileUploadId: this.setFileUploadId,
          setFileUploadBankStatement: this.setFileUploadBankStatement,
          setFileUploadSaWorkPermit: this.setFileUploadSaWorkPermit,
          setIsUnemployed: this.setIsUnemployed,
          setNewCustomerErrorObject: this.setNewCustomerErrorObject,
          setUserDetailsObject: this.setUserDetailsObject,
          setCreateQuoteCallPayload: this.setCreateQuoteCallPayload,
          setAdditionalServicesLte: this.setAdditionalServicesLte,
          setAdditionalVas: this.setAdditionalVas,
          setLteReviewData: this.setLteReviewData,
          setSelectedPackageType: this.setSelectedPackageType,
          setDebiCheckSelected: this.setDebiCheckSelected,
          setShowCallMeBack: this.setShowCallMeBack,
          setUnselectedContractCover: this.setUnselectedContractCover,
          setMonthlyCost: this.setMonthlyCost
        }}
      >
        {this.props.children}
      </SalesContext.Provider>
    );
  }
}